import { render, staticRenderFns } from "./SchoolGatherPlaceManageView.vue?vue&type=template&id=e7b1ae8a&scoped=true&"
import script from "./SchoolGatherPlaceManageView.vue?vue&type=script&lang=js&"
export * from "./SchoolGatherPlaceManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b1ae8a",
  null
  
)

export default component.exports